import React, { Component } from 'react';

export default class ProductCard extends Component {
  static defaultProps = {
    className: '',
    title: '',
    subTitle: '',
    halfHeightVal: 140,
    onClick: () => null
  };
  render() {
    // const img = 'https://source.unsplash.com/user/erondu/400x300';
    const { onClick, title, subTitle, main, img, halfHeight, halfHeightVal, className, titleBottom } = this.props;
    let height = main ? 440 : 280;
    height = halfHeight ? halfHeightVal : height;
    const styled = {
      backgroundImage: `url(${img})`,
      height,
      justifyContent: titleBottom ? 'flex-start' : 'flex-end'
    };
    return (
      <div
        className={`productCard ${main ? '-main' : 'default'} ${className}`}
        aria-hidden
        style={styled}
        onClick={onClick}
      >
        <div className="text">
          <h6 className="whiteGray subtitle">{subTitle}</h6>
          <h3 className="whiteGray title" dangerouslySetInnerHTML={{ __html: title }} />
        </div>
        <div className="title-bottom gold">
          {titleBottom}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProductCard.js